import { GlDisclosureDropdownGroup, GlDisclosureDropdownItem } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import Shortcuts from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/shortcuts.js?vue3';
import { keysFor, START_SEARCH_PROJECT_FILE } from '~/behaviors/shortcuts/keybindings';
import { keyboardShortcutsDisabled } from '~/behaviors/shortcuts/shortcuts_disabled';
import { InternalEvents } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tracking/index.js?vue3';
import { FIND_FILE_BUTTON_CLICK } from '~/tracking/constants';
import { showBlameButton } from '~/repository/utils/storage_info_utils';
import PermalinkDropdownItem from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/header_area/permalink_dropdown_item.vue?vue3';
export default {
    name: 'BlobRepositoryActionsGroup',
    components: {
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem,
        PermalinkDropdownItem
    },
    inject: [
        'blobInfo'
    ],
    props: {
        permalinkPath: {
            type: String,
            required: true
        }
    },
    computed: {
        findFileShortcutKey () {
            return keysFor(START_SEARCH_PROJECT_FILE)[0];
        },
        shortcutsDisabled () {
            return keyboardShortcutsDisabled();
        },
        blameItem () {
            return {
                text: __('Blame'),
                href: this.blobInfo.blamePath,
                extraAttrs: {
                    'data-testid': 'blame'
                }
            };
        },
        showBlameButton () {
            return showBlameButton(this.blobInfo);
        }
    },
    methods: {
        handleFindFile () {
            InternalEvents.trackEvent(FIND_FILE_BUTTON_CLICK);
            Shortcuts.focusSearchFile();
        }
    }
};
